import CategoryLists from "../features/finance/CategoryLists";

const CategoryListsPage = () => {
    return (
        <>
            <CategoryLists />
        </>
    )
}

export default CategoryListsPage